import { createChildFormViewContainer } from 'factories/ChildFormView'
import actions from 'actions/assets/assetTolerances'
import Component from 'components/Assets/Tolerances/FormView'

export default createChildFormViewContainer({ actions })(Component)
